var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigBlueDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7813 40C44.3937 42.4304 42.3881 44.4506 39.9678 45.8558C37.5475 47.2609 34.7986 48.001 32 48.001C29.2014 48.001 26.4525 47.2609 24.0322 45.8558C21.6119 44.4506 19.6063 42.4304 18.2187 40H8C6.93913 40 5.92172 40.4214 5.17157 41.1716C4.42143 41.9217 4 42.9391 4 44V56C4 57.0609 4.42143 58.0783 5.17157 58.8284C5.92172 59.5786 6.93913 60 8 60H56C57.0609 60 58.0783 59.5786 58.8284 58.8284C59.5786 58.0783 60 57.0609 60 56V44C60 42.9391 59.5786 41.9217 58.8284 41.1716C58.0783 40.4214 57.0609 40 56 40H45.7813Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32V4",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24L32 32L42 24",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigBlueDrawer);
export default __webpack_public_path__ + "static/media/BigBlueDrawer.cec6765d93398ebfe256ccc826afd162.svg";
export { ForwardRef as ReactComponent };